module.exports = __webpack_public_path__ + "static/logo-bdc02586eb19adeca02ebd2199f76551.svg";